import Binding from './Binding.js';
import { parseExpression } from './Parser.js';
import { sanitizeHtml, polyInvoke } from './Util.js';
import BindingRegistry from './BindingRegistry.js';


/**
 * [HtmlBinding description]
 *
 * @lends module:DataBinding.HtmlBinding#
 * @extends module:DataBinding.Binding
 *
 * @type {Object}
 */
const HtmlBinding = {

    name: 'bind-html',

    currentText: '',


    _make({ parentNode, text, scopeInfo }) {
        this.parentNode = parentNode;
        this.text = text;

        scopeInfo.bindings.push(this);
    },

    update(scope) {
        let text = parseExpression(this.text, scope, this.parentNode);

        if (this.currentText !== text) {
            const content = sanitizeHtml(text);

            polyInvoke(this.parentNode).innerHTML = '';

            Array.prototype.forEach.apply(content, [(node) => {
                this.parentNode.appendChild(node);
            }]);
            
            this.currentText = text;
        }
    },

    __proto__: Binding,
};

BindingRegistry.register(HtmlBinding);

export default HtmlBinding;



//////////////////
// WEBPACK FOOTER
// /Users/Jovan/TitanNanoDE/node_modules/@af-modules/databinding/lib/HtmlBinding.js
// module id = 41
// module chunks = 0